/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/QaItpOnedriveApproval.tsx
 * FILE_ID: JOBHUB-QA-ITP-ONEDRIVE-PANEL-001
 * PURPOSE: Tell the sender their Microsoft admin must approve OneDrive once.
 */
import { useEffect, useState } from 'react'
import type { OnedriveApproval } from './useQaItpOnedrive'

const BUTTON = 'w-full min-h-[44px] rounded px-2.5 text-[11px] font-medium sm:h-8 sm:w-auto sm:min-h-0'

export function QaItpOnedriveApproval({
  approval,
  onCopyLink,
  onSignIn,
  onUseAttachment,
}: {
  approval: OnedriveApproval
  onCopyLink: () => void
  onSignIn: () => void
  onUseAttachment: () => void
}) {
  const [copied, setCopied] = useState(false)
  useEffect(() => {
    if (!copied) return
    const timer = window.setTimeout(() => setCopied(false), 2000)
    return () => window.clearTimeout(timer)
  }, [copied])
  const domain = approval.email.includes('@') ? approval.email.split('@').pop() : approval.email

  return (
    <div className="rounded-lg border border-border bg-muted/40 p-3 text-xs">
      <p className="text-sm font-medium">Your Microsoft admin must approve OneDrive once</p>
      <p className="mt-1">
        Microsoft needs your Microsoft 365 admin to approve OneDrive for {approval.email} one time.
        Copy the link below and send it to your admin. After they approve, everyone at {domain} can share ITPs as OneDrive links.
      </p>
      <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <button
          type="button"
          className={`${BUTTON} border border-border hover:bg-muted`}
          onClick={() => {
            onCopyLink()
            setCopied(true)
          }}
        >
          {copied ? 'Link copied' : 'Copy admin approval link'}
        </button>
        <button type="button" className={`${BUTTON} text-primary`} onClick={onSignIn}>
          Try signing in anyway
        </button>
        <button type="button" className={BUTTON} onClick={onUseAttachment}>
          Send as attachment instead
        </button>
      </div>
    </div>
  )
}
